export const COMPLIANCE_STATUS = {
  PENDING: 'Pending',
  REJECTED: 'Rejected',
  APPROVED: 'Approved'
} as const; 